/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Atlassian Intelligence を使用',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Atlassian Intelligence を使用',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'AI を使用しています。結果は必ずご確認ください。',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': '情報',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': '現在のページのナレッジを含める',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence のロゴ',
  'fabric.editor.ai.components.backIconButton.backLabel': '戻る',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'キャンセル',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'キャンセル',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'キャンセル',
  'fabric.editor.ai.components.feedbackForm.badResponse': '悪い返答',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'フィードバックを送信しました',
  'fabric.editor.ai.components.feedbackForm.goodResponse': '良い返答',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': '最後の回答から続ける',
  'fabric.editor.ai.config.item.action.copyResponse': 'コピー',
  'fabric.editor.ai.config.item.action.responseCopied': 'コピーしました',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'クリップボードにコピーしました',
  'fabric.editor.ai.config.item.action.retryPrompt': '再試行',
  'fabric.editor.ai.experience-application.documentInsertError':
    '返信を挿入する際に問題が発生しました。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '応答を取得できませんでした。プロンプトまたは応答が、このリクエストの制限を超えています。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience.apiError': '応答がありませんでした。もう一度お試しください。',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': '何をすべきかを AI に伝えてください...',
  'fabric.editor.ai.experience.inlineCommentLoadingAnalyzing': '分析中',
  'fabric.editor.ai.experience.inlineCommentLoadingEditingTitle': '編集',
  'fabric.editor.ai.experience.inputTooShortError':
    '内容が短すぎて要約できません。内容を追加して、もう一度お試しください。',
  'fabric.editor.ai.experience.loadingAnalyzing': 'Rovo が分析中',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'Rovo が作動中です',
  'fabric.editor.ai.experience.loadingAriaTitle': '生成しています',
  'fabric.editor.ai.experience.loadingChangingTone': 'Rovo がトーンを変更中',
  'fabric.editor.ai.experience.loadingEditingTitle': 'Rovo が編集中です',
  'fabric.editor.ai.experience.loadingFixingSpellingAndGrammar': 'Rovo がスペルと文法を修正中',
  'fabric.editor.ai.experience.loadingLengthening': 'Rovo が内容を長く変更中',
  'fabric.editor.ai.experience.loadingPolishing': 'Rovo が推敲中',
  'fabric.editor.ai.experience.loadingShortening': 'Rovo が内容を短く変更中',
  'fabric.editor.ai.experience.loadingSummarizing': 'Rovo が要約中',
  'fabric.editor.ai.experience.loadingTranslating': 'Rovo が翻訳中',
  'fabric.editor.ai.experience.previewScreenLabel': 'プレビュー',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'エージェントに書き込む内容を指示するか、以下から選択します',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo のロゴ',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.acceptReject.acceptLabel': '受諾',
  'fabric.editor.ai.screens.acceptReject.rejectLabel': '破棄',
  'fabric.editor.ai.screens.discard.cancelLabel': '戻る',
  'fabric.editor.ai.screens.discard.discardLabel': '破棄',
  'fabric.editor.ai.screens.discard.noLabel': 'いいえ',
  'fabric.editor.ai.screens.error.warningIconLabel': '警告',
  'fabric.editor.ai.screens.discard.yesLabel': 'はい',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'エラー',
  'fabric.editor.ai.screens.error.cancelLabel': 'キャンセル',
  'fabric.editor.ai.screens.error.closeLabel': '閉じる',
  'fabric.editor.ai.screens.error.retryLabel': '再試行',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'ライブで更新されるコンテンツ: ',
  'fabric.editor.ai.screens.loading.iconAltText': 'アイコンを生成中',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': '改善事項はありません。お疲れさまでした。',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': '成功',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': '受諾',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'AI 生成コンテンツに対するアクション',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': '再試行',
  'fabric.editor.ai.screens.preview.betaLabel': 'ベータ版',
  'fabric.editor.ai.screens.preview.cancelLabel': 'キャンセル',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'お役に立ちましたか?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': '次に何をすべきかを AI に伝えてください',
  'fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder': '次にしたいことを Rovo に伝えてください',
  'fabric.editor.ai.screens.preview.discardLabel': '破棄',
  'fabric.editor.ai.screens.preview.disclaimer': '情報の質は異なる場合があります。',
  'fabric.editor.ai.screens.preview.disclaimerLink': '理由を確認する',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'クリア',
  'fabric.editor.ai.screens.preview.header.edit': 'プロンプトを編集',
  'fabric.editor.ai.screens.preview.header.edit.hover': '編集',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': '次に何をすべきかを {agentName} に尋ねてください',
  'fabric.editor.ai.screens.preview.refineButton': '改善',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': '改善',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence ロゴ',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.inlineCommentPlaceholder': '何をすべきかを説明',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'リンクを追加',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'ユーザーをメンション',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'リッチ コンテンツを挿入',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': '何をしたいかを説明',
  'fabric.editor.ai.screens.prompt.streaming.record': '録音',
  'fabric.editor.ai.screens.prompt.streaming.submit': '送信',
  'fabric.editor.ai.screens.prompt.submitLabel': '送信',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'AI に送信します',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - 選択済み',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': '削除',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': '提案',
  'fabric.editor.ai.shared.aiUniversalDescriptor': '書き込みアシスタント',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Atlassian Intelligence の助けを借りて文章を作成します',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': '書き込む',
  'fabric.editor.ai.shared.betaLabel': 'ベータ版',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.shared.generateContent.rovoButtonTitle': 'Rovo に質問する',
  'fabric.editor.ai.shared.rovoUniversalLongCallToAction': 'AI とコラボレーション',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'ベータ版',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NEW',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'AI に次のように伝える:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'エージェントに次のように伝える:',
};
